module.exports = __webpack_public_path__ + "static/media/amazon.0ae2e2ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/amazon.jpg
// module id = 1311
// module chunks = 0